import React from "react";
import { useFormContext } from "react-hook-form";
import { UseFormRegisterReturn } from "react-hook-form/dist/types";
import { spacing } from "../../styleConfig";
import * as C from "./styles";

type Props = {
  maxVal: number;
  onValueChange?: (value: number) => void;
};

export default function Counter({ maxVal, onValueChange }: Props) {
  const [value, setValue] = React.useState<number>(0);

  React.useEffect(() => {
    onValueChange && onValueChange(value);
  }, [value]);

  return (
    <C.MainContainer>
      <C.Minus
        style={{
          backgroundColor: value <= 0 ? "lightgray" : "",
          cursor: value <= 0 ? "no-drop" : "",
        }}
        onClick={() => {
          if (value > 0) setValue(value - 1);
        }}
      />
      <C.Input
        value={value}
        onChange={(e) => {
          let val = +e.target.value.replace(/\D+/g, "");

          if (val && val <= maxVal) {
            setValue(val);
          }
        }}
      />
      <C.Plus
        onClick={() => {
          if (maxVal && value < maxVal) setValue(value + 1);
        }}
        style={{
          backgroundColor: value >= maxVal ? "lightgray" : "",
          cursor: value >= maxVal ? "no-drop" : "",
        }}
      />
    </C.MainContainer>
  );
}
